import { ASSETS } from "../lib/constants";
import { useSeo } from "../lib/useSeo";
import { PageHero, WaiverBlock } from "../components/bits";
import { Reveal } from "../components/Reveal";

const steps = [
  { n: "01", title: "General Entry — No Waiver", body: "You do NOT need a waiver to enter Higher Ground, shop, or speak with our team. Just bring a valid 21+ ID." },
  { n: "02", title: "Safe Use Facility & Summer Garden", body: "Planning to access our Safe Use Treatment Facility or Summer Garden? That's the only time a waiver is required." },
  { n: "03", title: "Takes Under a Minute", body: "Complete the short Safe Use Waiver online or via the QR code before entering those areas — quick, safe, and compliant." },
];

export default function Waiver() {
  useSeo("/waiver");
  return (
    <div data-testid="waiver-page">
      <PageHero
        label="Welcome to Higher Ground"
        title="Safe Use Treatment Facility & Summer Garden Waiver"
        subtitle="A waiver is not required for general entry into Higher Ground. It's only needed to access our Safe Use Treatment Facility and Summer Garden."
        image={ASSETS.exteriorWide}
        testid="waiver-page-hero"
      />

      <section className="bg-ink py-20 md:py-28">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <div className="grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={0.1 * i}>
                <div className="flex h-full flex-col bg-ink p-8 md:p-12">
                  <span className="font-display text-6xl font-extralight text-gold/30 md:text-7xl">{s.n}</span>
                  <h3 className="mt-6 font-display text-xl font-light uppercase tracking-[0.1em] text-white">{s.title}</h3>
                  <p className="mt-4 leading-relaxed text-white/55">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <WaiverBlock />
    </div>
  );
}
